<mat-form-field appearance="outline" class="w-100" (click)="validateField()">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [multiple]="multiple">
    <mat-option *ngFor="let provider of providers" [value]="provider.name">
      {{ provider.name }}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="control.hasError('required')">Campo obrigatório</mat-error>
</mat-form-field>
